module.exports = __webpack_public_path__ + "a9c736758c572a85a838d8c5c6791cec.png";